import React from "react";
import { useCountdown } from "@/features/Comprar/vida-devolucion/step-initial/hooks/useCountdown";
import { getNextResetDate } from "@/utils/helpers";
import "./styles.scss";

export const Timer = ({ startDate, finalDate, resetDays = 0 }) => {
  const nextResetDate = getNextResetDate(startDate, finalDate, resetDays);
  const { days, hours, minutes, show } = useCountdown(
    nextResetDate ?? new Date()
  );

  const showBannerCyber = !!nextResetDate && !(hours <= -1 || !show);

  const format = (num) => (num < 10 ? `0${num}` : num);

  if (!showBannerCyber) return null;

  return (
    <div className="timer">
      <div className="timer__box">
        <p>{days}d</p>
      </div>
      <p>:</p>
      <div className="timer__box">
        <p>{format(hours)}h</p>
      </div>
      <p>:</p>
      <div className="timer__box">
        <p>{format(minutes)}m</p>
      </div>
    </div>
  );
};
